module.exports = __webpack_public_path__ + "static/media/defaultM.0e63d6bf.svg";